import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import axiosInstance from '../axiosConfig';
import { useDispatch } from 'react-redux';
import { setAlert } from '../actions/alert';
import { Oval } from 'react-loader-spinner';

const Contact = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const { name, email, subject, message } = formData;
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = async e => {
        e.preventDefault();

        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        setLoading(true);
        try {
            await axiosInstance.post('/api/contacts/', { 
                name, 
                email, 
                subject, 
                message 
            }, config);
            
            dispatch(setAlert('Message Sent Successfully', 'success'));
            setSubmitted(true);
            
            // Reset form
            setFormData({
                name: '',
                email: '',
                subject: '',
                message: ''
            });
        } catch (err) {
            dispatch(setAlert('Error Sending Message', 'error'));
        } finally {
            setLoading(false);
            window.scrollTo(0, 0);
        }
    };

    return (
        <div className='contact-page'>
            <Helmet>
                <title>OffGrid Developments - Contact Us</title>
                <meta
                    name='description'
                    content='Contact OffGrid Developments LLC'
                />
            </Helmet>
            
            <div className="contact-page__container">
                <div className="contact-page__header">
                    <h1 className="contact-page__title">Contact Us</h1>
                   
                </div>

                <div className="contact-page__content">
                    <div className="contact-page__form-container">
                        {submitted ? (
                            <div className="contact-page__success">
                                <h2>Thank You!</h2>
                                <p>Thank you for reaching out to Off Grid Developments LLC. 
                                We've received your message and will get back to you as soon as possible.</p>
                                <p className="contact-page__signature">Kind regards,<br />Off Grid Developments Team</p>
                                <button 
                                    className="contact-page__form-button"
                                    onClick={() => setSubmitted(false)}
                                >
                                    Send Another Message
                                </button>
                            </div>
                        ) : (
                            <form className='contact-page__form' onSubmit={onSubmit}>
                                <div className="contact-page__form-group">
                                    <label className='contact-page__form-label' htmlFor='name'>Name*</label>
                                    <input 
                                        className='contact-page__form-input' 
                                        name='name' 
                                        type='text' 
                                        placeholder='Your Full Name' 
                                        onChange={onChange} 
                                        value={name} 
                                        required 
                                    />
                                </div>

                                <div className="contact-page__form-group">
                                    <label className='contact-page__form-label' htmlFor='email'>Email*</label>
                                    <input 
                                        className='contact-page__form-input' 
                                        name='email' 
                                        type='email' 
                                        placeholder='Your Email Address' 
                                        onChange={onChange} 
                                        value={email} 
                                        required 
                                    />
                                </div>

                                <div className="contact-page__form-group">
                                    <label className='contact-page__form-label' htmlFor='subject'>Subject*</label>
                                    <input 
                                        className='contact-page__form-input' 
                                        name='subject' 
                                        type='text' 
                                        placeholder='Message Subject' 
                                        onChange={onChange} 
                                        value={subject} 
                                        required 
                                    />
                                </div>

                                <div className="contact-page__form-group">
                                    <label className='contact-page__form-label' htmlFor='message'>Message*</label>
                                    <textarea 
                                        className='contact-page__form-textarea'
                                        name='message'
                                        rows='7'
                                        placeholder='Your Message'
                                        onChange={onChange} 
                                        value={message}
                                        required
                                    />
                                </div>

                                {loading ? (
                                    <div className='contact-page__form-loader'>
                                        <Oval
                                            color="#1e8449"
                                            height={50}
                                            width={50}
                                        />
                                    </div>
                                ) : (
                                    <button className='contact-page__form-button' type='submit'>
                                        Send Message
                                    </button>
                                )}
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
